import * as Yup from "yup";
import store from "../../store";
import { showAlert } from "../../store/actions/feedback";
import { State } from "../user-details/models/user-interface";

interface SelectOptions {
  value: boolean | string;
  label: string;
}
const convertBooleanValuesToString = (options: []) => {
  options?.forEach((element: SelectOptions) => {
    if (typeof element?.value === "boolean") {
      element.value = element.value.toString();
    }
  });
  return options;
};
const intializeFieldValues = (fieldType: unknown, fieldOptions: any) => {
  if (fieldType === "Currency") {
    return "0.00";
  }
  if (fieldType === "Number") {
    return 0;
  }
  if (fieldType === "radio") {
    return true;
  }
  return "";
};
export function initializeForm(data: any) {
  const questionFields = data?.questions;
  const state = data?.state;
  const formValues = {};
  if (!questionFields) return;
  formValues["state"] = state;
  questionFields.forEach((field) => {
    const answer = field.answers;
    const fieldName = field?.key;
    const fieldType = field?.input_question_format?.type;

    let fieldOptions = field?.input_question_format?.options;
    if (fieldOptions?.length === 2) {
      fieldOptions = convertBooleanValuesToString(fieldOptions);
    }
    let fieldValue =
      answer[0]?.value ?? intializeFieldValues(fieldType, fieldOptions);
    if (fieldValue === false && fieldType === "Select") {
      fieldValue = "false";
    }
    formValues[fieldName] = fieldValue;
  });
  const initValues = {
    ...formValues,
  };
  return initValues;
}
export function createValidationSchema(data) {
  const questionFields = data?.questions;
  if (!questionFields) return;
  const formFields = {};
  questionFields.forEach((field) => {
    const key = field?.key;
    const label = field?.label;
    const requiredField = " Field is required.";
    const isRequired = " is required.";
    formFields[key] = Yup.string().required(
      label ? label + isRequired : requiredField
    );
  });
  const fields = Yup.object({
    ...formFields,
  });
  return fields;
}
export function initializeEmployeeState(stateAbbr: string, usStates: any) {
  let result: any = [];

  for (let state of usStates) {
    if (state.id === stateAbbr) {
      result = [
        {
          id: state.id,
          abbr: state.abbr,
          name: state.name,
        },
      ];
      break;       
    }
  }
  return result;
}
export function createFormAnswers(formData, employeeData) {
  const response: any = [];
  const responseObject = {
    employee_uuid: employeeData.employee_uuid,
    states: [
      {
        state: employeeData.state,
        questions: [],
      },
    ],
  };

  for (const [key, value] of Object.entries(formData)) {
    if (key === "state") continue;
    let formattedValue;
    formattedValue =
      value === "true" || value === "false" ? value === "true" : value;
    const obj: any = {
      key: key,
      answers: [
        {
          value: formattedValue,
        },
      ],
    };
    response.push(obj);
  }
  responseObject.states[0].questions = response;
  return responseObject;
}

export function reInitializeFormOnSubmitError(data: any) {
  const formDataEntered = data?.states[0]?.questions;
  const state = data?.states[0]?.state;
  if (!formDataEntered) return;
  const formValues = {};
  formValues["state"] = state;
  formDataEntered.forEach((element) => {
    let fieldName: any = element?.key;
    const answer = element?.answers[0]?.value;
    formValues[fieldName] = answer;
  });
  const initValues = {
    ...formValues,
  };
  return initValues;
}
const dispatchErrorToStore = (error: string) => {
  store.dispatch(
    showAlert({
      alertType: "error",
      alertText: error,
    })
  );
};
export function handleError(error) {
  const errorObject = error?.errors?.payroll_org_errors;
  if (!errorObject) return;
  errorObject.forEach((element) => {
    const error = element?.questions[0]?.answers[0]?.errors[0];
    dispatchErrorToStore(error);
  });
}
